exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no_sales_container {\n  width: 100%;\n  padding: 20px 0;\n  background-color: white;\n  text-align: center;\n  font-weight: bold; }\n\n.no_sales_container span {\n  font-weight: normal;\n  color: #a4a4a4;\n  margin-top: 10px;\n  display: inline-block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/menu-settings/menu-settings.component.scss
// module id = 706
// module chunks = 0